import { css } from 'styled-components';

export const tapHighlightResetStyles = css`
  -webkit-tap-highlight-color: transparent;
`;

export const nonSelectableSurfaceStyles = css`
  user-select: none;
  -webkit-user-select: none;
`;

export const structuralControlResetStyles = css`
  appearance: none;
  -webkit-appearance: none;
  ${tapHighlightResetStyles};
  outline: none;
  border: 0;
  background: transparent;
  padding: 0;
  resize: none;
`;

export const inheritedControlTypographyStyles = css`
  color: inherit;
  font-family: inherit;
  line-height: inherit;
`;

export const dynamicViewportHeightStyles = css`
  min-height: 100svh;
  height: 100svh;

  @supports not (height: 100svh) {
    min-height: 100vh;
    height: 100vh;
  }

  @supports (height: 100dvh) {
    min-height: 100dvh;
    height: 100dvh;
  }
`;

export const pressableControlLifecycleStyles = css`
  ${tapHighlightResetStyles};
  touch-action: manipulation;
  -webkit-touch-callout: none;
  ${nonSelectableSurfaceStyles};
  transition: transform 120ms ease, opacity 120ms ease, filter 120ms ease;
  transform-origin: center;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.emphasis};
    outline-offset: 2px;
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
    transform: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      filter: brightness(0.98);
    }
  }
`;

export const textInputLifecycleStyles = css`
  ${tapHighlightResetStyles};
  touch-action: manipulation;
  user-select: text;
  -webkit-user-select: text;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.brand.primary};
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
  }
`;
